import makeStyles from "@mui/styles/makeStyles";
import { getBrandCustom } from "Util/getCustomColor";

const styles = makeStyles((theme) => ({
  mainDiv: {
    marginTop: 10,
    padding: "0 8px",
    width: "100%",
  },
  title: {
    display: "flex",
    alignItems: "center",
    marginTop: 20,
  },
  divColumn: {
    display: "flex",
    flexDirection: "column",
    marginTop: "12px",
  },
  buttonAdd: {
    marginRight: "24px",
  },
  buttonViewAll: {
    color: "#3F6280",
    "&:hover": {
      color: "#3F6280",
    },
  },
  userPlus: {
    color: "#FFFFFF",
    marginRight: "13px",
  },
  businessLabel: {
    fontWeight: "bold",
    color: "#465869",
    lineHeight: "18px",
    fontSize: "16px",
    fontFamily: `'Manrope', sans-serif`,
  },
  contactsCount: {
    background: getBrandCustom("primaryColor", "#38cfc4"),
    color: "#FFF",
    fontSize: "10px",
    fontWeight: 600,
    borderRadius: "16px",
    padding: "4px 6px",
    marginLeft: "16px",
    lineHeight: "10px",
    fontFamily: `'Manrope', sans-serif`,
  },
  buttonsContainer: {
    marginTop: "12px",
    display: "flex",
    justifyContent: "flex-start",
  },
  addContactModal: {
    zIndex: 900,
  },
  scroll: {
    overflowY: "scroll",
  },
}));

export default styles;
